import { render, staticRenderFns } from "./auditAuthOwnerList.vue?vue&type=template&id=53bef1ac&scoped=true"
import script from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerList.vue?vue&type=style&index=0&id=53bef1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bef1ac",
  null
  
)

export default component.exports